<template>
  <div class="orderContent fuwu fuwuorder">
    <header class="pageHeader">
      <div class="hBtnl" @click="gotoBack()">
        <button class="btnDiv btnDivd btnDivn">
          <i class="iconfont">&#xe601;</i>
        </button>
      </div>
      <h1 v-if="pageName == 'forward'" class="pageHeader-title">预约祭扫</h1>
      <h1 v-if="pageName == 'tomb'" class="pageHeader-title">购墓登记</h1>
      <h1 v-if="pageName == 'repair'" class="pageHeader-title">在线报修</h1>
      <div class="hBtnr">
        <button class="btnDiv btnDivd btnDivn">
          <!---->
          <label class="btnDiv-text"></label>
        </button>
      </div>
    </header>
    <div v-if="list.length == 0" class="noData">
      <p v-if="pageName == 'forward'">暂无预约祭扫信息~</p>
      <p v-if="pageName == 'tomb'">暂无购墓登记信息~</p>
      <p v-if="pageName == 'repair'">暂无在线报修信息~</p>
    </div>
    <div v-else>
      <template v-if="pageName == 'forward'">
        <div class="orders" v-for="(item, index) in list" :key="index">
          <div class="title">
            <span class="order">订单号 : {{ item.msgNo }}</span>
            <span class="status">{{ item.dealStatus.label }}</span>
            <img src="../../../assets/li.svg" class="line" />
          </div>
          <div class="shop" @click="goto('forward', item.id)" style="min-height: 18rem;">
            <div class="fuwuInfo">
              <span class="name">预约时间：{{ $substr(item.predate, 0, 10) }}</span>
              <span class="name">同行人数：{{ item.userCount }}人</span>
              <span class="name">预约人姓名：{{ item.userName }}</span>
              <span class="name">预约人手机号：{{ item.mobile }}</span>
              <span class="name">预约人身份证：{{ item.idCard }}</span>
              <span class="name">提交时间：{{ item.createDate }}</span>
            </div>
          </div>
        </div>
      </template>
      <template v-if="pageName == 'tomb'">
        <div class="orders" v-for="(item, index) in list" :key="index" style="min-height:13rem;">
          <div class="title">
            <span class="order">订单号 : {{ item.msgNo }}</span>
            <span class="status">{{ item.dealStatus.label }}</span>
            <img src="../../../assets/li.svg" class="line" />
          </div>
          <div class="shop" @click="goto('tomb', item.id)" style="min-height:13rem;">
            <div class="fuwuInfo">
              <span class="name">预约时间：{{ $substr(item.predate, 0, 10) }}</span>
              <span class="name">预约人姓名：{{ item.userName }}</span>
              <span class="name">预约人手机号：{{ item.mobile }}</span>
              <span class="name" style="word-wrap:break-word">备注：{{ item.userMemo }}</span>

              <span class="name">提交时间：{{ item.createDate }}</span>
            </div>
          </div>
        </div>
      </template>
      <template v-if="pageName == 'repair'">
        <div class="orders" v-for="(item, index) in list" :key="index" style="min-height:13rem;">
          <div class="title">
            <span class="order">订单号 : {{ item.msgNo }}</span>
            <span class="status">{{ item.dealStatus.label }}</span>
            <img src="../../../assets/li.svg" class="line" />
          </div>
          <div class="shop" @click="goto('repair', item.id)" style="min-height:13rem;">
            <div class="fuwuInfo">
              <span class="name">墓位编号：{{ item.repairNo }}</span>
              <span class="name" style="word-wrap:break-word">说明：{{ item.content }}</span>
              <!-- <img src="../../../assets/shop.jpg" class="pic2" /> -->
              <span class="name">提交时间：{{ item.createDate }}</span>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'order',
  data() {
    return {
      count: 0,
      isLoading: false,
      pageName: '',
      list: [],
      total: 0,
    }
  },
  created() {
    this.pageName = this.$route.params.type

    if (this.pageName == 'forward') {
      this.queryForwardPage()
    } else if (this.pageName == 'tomb') {
      this.queryTombPage()
    } else if (this.pageName == 'repair') {
      this.queryRepairPage()
    }
  },
  mounted() {},
  methods: {
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false
        this.count++
      }, 1000)
    },
    queryForwardPage() {
      var that = this
      this.$queryPage(
        'MsgForward',
        { myId: this.$store.getters.userId, sort: { predate: 'desc' } },
        [
          'id',
          'msgNo',
          'predate',
          'mobile',
          'idCard',
          'userName',
          'userCount',
          'dealStatus',
          'dealDate',
          'dealResult',
          'createDate',
        ],
        function(res) {
          that.$fill(that.list, res['data'])
          that.total = res['total']
        }
      )
    },
    queryTombPage() {
      var that = this
      this.$queryPage(
        'MsgTomb',
        { myId: this.$store.getters.userId, sort: { predate: 'desc' } },
        [
          'id',
          'msgNo',
          'predate',
          'mobile',
          'userName',
          'userMemo',
          'dealStatus',
          'dealDate',
          'dealResult',
          'createDate',
        ],
        function(res) {
          that.$fill(that.list, res['data'])
          that.total = res['total']
        }
      )
    },
    queryRepairPage() {
      var that = this
      this.$queryPage(
        'MsgRepair',
        { myId: this.$store.getters.userId, sort: { createDate: 'desc' } },
        ['id, msgNo, repairNo, content, dealStatus, dealDate, dealResult, createDate, gallery'],
        function(res) {
          that.$fill(that.list, res['data'])
          that.total = res['total']
        }
      )
    },
    goto(type, id) {
      this.$router.push({ path: '/shop/fuwu/' + type + '/' + id })
    },
    gotoBack() {
      this.$router.push({ path: '/my' })
    },
  },
  watch: {},
}
</script>

<style>
.fuwuorder .orders {
  width: 35.5rem;
  /* height: auto; */
  background-color: #fff;
  margin-top: 1rem;
  margin-left: 2rem;
  padding-left: 1.5rem;
  padding-top: 1.5rem;
  position: relative;
  top: 0;
  left: -1rem;
}
.fuwuorder .orders .title {
  height: 5rem;
  width: 35.5rem;
  font-size: 1.4rem;
  margin-top: -1.5rem;
  margin-left: -1.5rem;
  padding-left: 1.7rem;
  padding-top: 1.5rem;
}
.fuwuorder .orders .title .status {
  float: right;
  margin-right: 1rem;
  font-size: 1.4rem;
}
.fuwuorder .title .line1 {
  position: relative;
  left: -1.5rem;
  top: -0.5rem;
  width: 35.5rem;
}
.fuwu .orders .shop {
  width: 35.5rem;
  margin-top: 1rem;

  margin: 0.5rem 0 1rem;
  line-height: 2.5rem;
}
.fuwuorder .shop .pic2 {
  width: 8rem;
  height: 8rem;
}
.fuwu .orders .shop .fuwuInfo {
  width: 32.6rem;
  /* height: 16.6rem; */
  position: relative;

  display: flex;
  flex-direction: column;
}
.fuwu .orders .shop .fuwuInfo .name {
  font-size: 1.4rem;
  display: block;
  margin-top: 0.5rem;
  padding-bottom: 1.5rem;
  /* line-height: 2.5rem; */
}
.fuwuorder .shop .fuwuInfo .size {
  color: #999;
  font-size: 1.2rem;
  position: relative;
  top: 1rem;
}
.fuwuorder .shop .fuwuInfo .money {
  color: #15a892;
  font-size: 1.6rem;
  position: relative;
  top: 1.5rem;
}

.fuwuorder .shop .fuwuInfo .num {
  float: right;
  margin-right: -1.4rem;
  font-size: 1.4rem;
}
.fuwuorder .shop .line {
  position: relative;
  top: -8rem;
  left: -1.5rem;
}

.fuwuorder .line {
  width: 100%;
  border-bottom: 1px solid #eee;
}
.fuwuorder .bottom {
  width: 32.9rem;
  height: 4rem;
  padding-top: 0.8rem;
}
.fuwuorder .bottom span {
  font-size: 1.4rem;
}
.fuwuorder .bottom .pay {
  background-color: #15a892;
  color: #fff;
}
.fuwuorder .bottom ul li div {
  width: 8rem;
  height: 3rem;
  border: 0.1rem solid #eee;
  font-size: 1.3rem;
  list-style: none;
  float: right;
  position: relative;
  left: 11.8rem;
  top: -2.5rem;
  margin-right: 1rem;
  padding-top: 0.6rem;
  text-align: center;
}

.fuwuorder .pageHeader {
  background-color: #fff;
  color: #333;
  -ms-flex-align: center;
  align-items: center;

  box-sizing: border-box;

  display: -ms-flexbox;
  display: flex;
  font-size: 14px;
  height: 40px;
  line-height: 1;
  padding: 0 10px;
  position: relative;
  text-align: center;
  white-space: nowrap;
}

.fuwuorder .hBtnl {
  -ms-flex: 0.5;
  flex: 0.5;
  text-align: left;
}
.fuwuorder .hBtnr {
  -ms-flex: 0.5;
  flex: 0.5;
  text-align: right;
}
.fuwuorder .pageHeader .pageHeader-title {
  font-size: 18px;
}
.fuwuorder .pageHeader-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: inherit;
  font-weight: 400;
  -ms-flex: 1;
  flex: 1;
}

.fuwuorder .hBtn {
  -ms-flex: 0.5;
  flex: 0.5;
}
.fuwuorder .pageHeader .btnDiv {
  background-color: transparent;
  border: 0;
  box-shadow: none;
  color: inherit;
  display: inline-block;
  padding: 0;
  font-size: inherit;
}
.fuwuorder .btnDivn,
.fuwuorder .btnDivs {
  display: inline-block;
  padding: 0 12px;
}
.fuwuorder .btnDivd {
  color: #656b79;
  background-color: #f6f8fa;
  box-shadow: 0 0 1px #b8bbbf;
}
.fuwuorder .noData {
  width: 20rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.fuwuorder .show {
  display: block !important;
}
.fuwuorder .noData:before {
  width: 100%;
  height: 9.5rem;
  display: block;
  content: '';
  background: url(../../../assets/noData.png) 50% no-repeat;
  background-size: contain;
}

.fuwuorder .noData p {
  font-size: 1.4rem;
  color: #999;
  text-align: center;
  height: 2.4rem;
  line-height: 2.4rem;
  margin-top: 1.4rem;
}
</style>
